import { HOUR_MS } from '@calm/web-common/dist/time';
import { createCalmPublicApi } from '@rhg/libs/api/create-calm-public-api';
import { queryKeys, useQuery } from '@rhg/libs/react-query';

export function useDeviceConsent() {
    const { data, ...otherProps } = useQuery({
        queryKey: [queryKeys.deviceConsent],
        queryFn: async () => {
            const calmPublicApi = createCalmPublicApi();

            const response = await calmPublicApi.getCalmPublicDeviceConsent();

            return response.data;
        },
        staleTime: 8 * HOUR_MS,
    });
    return {
        deviceConsent: data,
        ...otherProps,
    };
}
